import { Stack } from '@mui/material'
import ContentBody from './ContentBody'
import ContentHeader from './ContentHeader'

export default function Content(){

    return(

        <Stack direction="column" spacing={2.5}>

            <ContentHeader/>
            <ContentBody />            
            
        </Stack>

    )

}